import { FC } from "react";
import PrepState50Svg from "../../public/icons/PrepState50.svg";
import { IconProps, useAddMissingAntIconClass } from "../hooks/use-add-missing-ant-icon-class";

export const GeometryBuildUpPrepState50Icon: FC<IconProps> = (iconProps) =>
  <span role="img" {...useAddMissingAntIconClass(iconProps)}><PrepState50Svg/></span>;
